/// <reference path="../../adpIntegration/sections/adpIntegration.employee.section.ts" />

module Meevo.Plugins.AdpWfnIntegration {
    
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class WfnEmployeeSection extends Meevo.Plugins.AdpIntegration.EmployeeSection {

        private adpIntegrationDataService: Meevo.Components.CommonClasses.IADPIntegrationService;
   
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            modalService: Meevo.Components.Modal.IModalService,
            busyService: Components.Busy.IBusyService,
            $rootScope: ng.IRootScopeService,
            appSettings: Meevo.Components.Common.IAppSettings,
            sectionSecurityKey?: string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                noun,
                identityService,
                modalService,
                busyService,
                $rootScope,
                appSettings,
                sectionSecurityKey);
            this.adpIntegrationDataService = this.dataService as Meevo.Components.CommonClasses.IADPIntegrationService;
        }
    }
}